import { schema, types } from 'papr'
import { PROJECT_MEMBER_ROLES } from './docs-project'

export const USER_INVITE_STATUS = ['pending', 'accepted', 'rejected', 'revoked'] as const

export type UserInviteStatus = (typeof USER_INVITE_STATUS)[number]

export const docsProjectMemberInviteSchema = schema(
	{
		projectId: types.objectId({ required: true }),
		invitedEmail: types.string({ required: true }),
		// Right now a user ID is required but not in the future. This is why it is optional.
		invitedUser: types.objectId(),
		invitedBy: types.objectId({ required: true }),
		role: types.enum(PROJECT_MEMBER_ROLES, {
			required: true,
		}),
		status: types.enum(USER_INVITE_STATUS, {
			required: true,
		}),
		dateInvited: types.date({ required: true }),
		inviteToken: types.string({ required: true }),
	},
	{
		timestamps: true,
	},
)

export type DocsProjectMemberInviteDocument = (typeof docsProjectMemberInviteSchema)[0]
export type DocsProjectMemberInviteDefaults = (typeof docsProjectMemberInviteSchema)[1]
